/* eslint-disable @typescript-eslint/no-unused-expressions */
import React from 'react';
import {
  chatboxEllipsesOutline,
  logoWhatsapp,
  mailOutline,
} from 'ionicons/icons';
import { IonicButton } from 'ionic-ui';
import Layout from './Layout';
import { SignUpPageProps } from './SignUp';
import VerificationMethodSelector from '../../components/auth-components/signup/VerificationMethodSelector';
import { useFormContext } from 'react-hook-form';
import { useDialog } from '../../context/Dialog';
import EmailVerificationDialog from '../../components/auth-components/signup/dialogs/EmailVerificationDialog';
import z from 'zod';
import { signupSchema } from '../../schemas/signupSchema';

const SignUp02: React.FC<SignUpPageProps> = ({ previous, next }) => {
  const useForm = useFormContext<z.infer<typeof signupSchema>>();
  const { openDialog } = useDialog();

  const goBack = ((event: MouseEvent) => {
    event.preventDefault();
    previous && previous();
    return;
  }) as unknown as React.MouseEventHandler<HTMLButtonElement>;

  //THIS SENDS A TOKEN TO USER'S EMAIL
  const verifyWithEmail = () => {
    openDialog(
      <EmailVerificationDialog
        onNext={next}
        useForm={useForm}
        verificationMethod="email"
      />
    );
  };

  const verifyWithSms = () => {
    openDialog(
      <EmailVerificationDialog
        onNext={next}
        useForm={useForm}
        verificationMethod="sms"
      />
    );
  };

  const verifyWithWhatsapp = () => {
    openDialog(
      <EmailVerificationDialog
        onNext={next}
        useForm={useForm}
        verificationMethod="whatsapp"
      />
    );
  };

  const hasPhone = !!useForm.getValues('phone');

  const verificationMethods = [
    {
      icon: mailOutline,
      title: 'Verify via Email',
      subtitle: 'Tap to receive a verification code.',
      onClick: verifyWithEmail,
    },
    {
      icon: chatboxEllipsesOutline,
      title: 'Verify via SMS',
      subtitle: 'Get a 6-digit code via SMS to confirm your number.',
      onClick: hasPhone ? verifyWithSms : undefined,
      disabled: !hasPhone,
    },
    {
      icon: logoWhatsapp,
      title: 'Verify via WhatsApp',
      subtitle: 'Receive your code instantly on WhatsApp.',
      onClick: hasPhone ? verifyWithWhatsapp : undefined,
      disabled: !hasPhone,
    },
  ];

  return (
    <>
      <Layout
        uiType="signup"
        title="Verify your Account"
        description="Choose how to verify your account"
        step={2}
        totalStep={2}
      >
        <div className="flex flex-col gap-6 w-[100%]">
          {/* verification methods */}
          {verificationMethods.map((method) => (
            <VerificationMethodSelector {...method} />
          ))}

          {/* Buttons */}
          <div className="flex justify-between mt-8">
            <IonicButton
              onClick={goBack}
              variant="outline"
              type="button"
              size="xlg"
              className={`text-primary`}
            >
              Previous
            </IonicButton>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default SignUp02;
